import script from "./CaseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseCard.vue?vue&type=script&setup=true&lang=js"

import "./CaseCard.vue?vue&type=style&index=0&id=4f255fe5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f255fe5"]])

export default __exports__